<script>
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  name: 'chart1',
  mixins: [reactiveProp],
  props: ['chartData', 'option1'],
  data() {
    return {
      data: {
        labels: ["frequency"],
        datasets: [
          {
            label: 'sound 1',
            data: this.chartData,
            showLine: true,
            borderColor: 'rgba(60, 220, 150, 0.8)',
            lineTension: 0,
            pointRadius: 0,
            fill: false,
            type: "scatter"
          },
        ]
      },
      options: {
        //responsive: false,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          /*x: {
            type: "logarithmic",
          },
          y: {
            type: "logarithmic",
          },*/
          xAxes: [{
            type: "logarithmic",
            ticks: {
              min: 10,
              max: 10000,
            },
            scaleLabel: {
              display: true,
              labelString: "Frequency[Hz]",
              fontSize: 16,
            },
          }],
          /*xAxes: [{
            scaleLabel: {
              display: true,
              labelString: "Frequency[kHz]",
              fontSize: 16,
            },
            gridLines: {
              lineWidth: 1,
            },
            ticks: {
              min: 0,
              max: 1200,
              fontSize: 16,
            },
            // type: 'logarithmic',
          }],*/
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: "dB",
              fontSize: 16,
            },
            /*ticks: {
              min: -12,
              max: -2,
              stepSize: 2,
              fontSize: 18,
            },*/
          }]
        }
      }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}
</script>